var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoRightArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38569 0.15976C6.17267 -0.0532532 5.82731 -0.0532532 5.6143 0.15976C5.40128 0.372773 5.40128 0.718135 5.6143 0.931148L10.6831 5.99999L5.6143 11.0688C5.40128 11.2818 5.40128 11.6272 5.6143 11.8402C5.82731 12.0532 6.17267 12.0532 6.38569 11.8402L11.8402 6.38569C12.0532 6.17267 12.0532 5.82731 11.8402 5.6143L6.38569 0.15976ZM0.931148 0.159775C0.718135 -0.053238 0.372773 -0.053238 0.15976 0.159775C-0.0532532 0.372788 -0.0532532 0.71815 0.15976 0.931163L5.2286 6.00001L0.15976 11.0689C-0.0532532 11.2819 -0.0532532 11.6272 0.15976 11.8402C0.372773 12.0533 0.718135 12.0533 0.931148 11.8402L6.38569 6.3857C6.5987 6.17269 6.5987 5.82733 6.38569 5.61431L0.931148 0.159775Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoRightArrows);
export default __webpack_public_path__ + "static/media/TwoRightArrows.bb742614.svg";
export { ForwardRef as ReactComponent };